<template>
  <Layout>
    <!-- <Appdowload></Appdowload> -->
    <div class="bordertop3" v-if="!show_ie">
      <div class="header">
        <HeaderNav name="3"></HeaderNav>
      </div>
      <div class="online-detail">
        <div class="head container-padding">
          <div class="bread">
            <p>
              <router-link :to="{path:'/online/index'}">线上课程</router-link>
              &nbsp;&nbsp;\&nbsp;&nbsp;{{info.course_name}}
            </p>
          </div>
          <div class="head-detail">
            <div class="img flt">
              <img v-if="info.images==undefined || info.images.length<=0"
               src="https://file.jkxuetang.com/khyoga/banner.jpg" />
              <el-carousel width="380px;" height="380px" v-else>
                <el-carousel-item v-for="item in info.images" :key="item">
                  <img :src="'http://'+item" style="width: 380px;height:380px"  />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="info flt">
              <h1>{{info.course_name}}</h1>
              <div class="jieshao" style="white-space:pre-wrap" v-html="info.course_introduction"></div>
              <div class="price-div">
                <p>
                  <span class="price-span">￥{{info.course_price}}</span>
                </p>
              </div>
              <!-- <div class="absolute-bottom">
                <a href="javascript:;" class="btn-advisory">咨询</a>
              </div> -->
              <div>
               <el-button type="danger" @click="zixun"  class="zixun_button" round>咨询</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="online-body container-padding">
          <div :style="{width:info.left_width}" class="flt train-body-left">
            <div class="detail">
              <div class>
                <h1>课程详情</h1>
              </div>
              <div v-html="info.detail" class="course-content"></div>
            </div>
          </div>
          <!-- v-if="info.has_teacher==1"  -->
          <div class="flt train-body-right">
            <div class="title">
              <h1>教师介绍</h1>
            </div>
            <div v-for="(i,index) in info.teacher" :key="index">
              <div class="avatar">
              <img
                :src="'http://'+i.avatar" v-if="i.avatar!=null"
              />
              <img src="http://www.khyoga.net/upload/image/20200721/69ae0a70c4d40f0a38f0487d11d8187c.jpg" v-else>
              <h1>{{i.teacher_name}}</h1>
              <h2>{{i.teach_level_string}}</h2>
            </div>
            <div class="experience">
              <h1>教师简介</h1>
              <p>{{teacher.teacher_introduction}}</p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterDes v-if="!show_ie"></FooterDes>
    <HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import Appdowload from "../../components/Appdowload";
import HintIE from "../../components/HintIE";
export default {
  components: {
    Appdowload: Appdowload,
    HeaderNav: headernav,
    FooterDes: footer,
    HintIE: HintIE
  },
  data() {
    return {
      info: {},
      id: 0,
      teacher: {},
      show_ie: false
    };
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)this.show_ie = true; //不支付IE
    },
    zixun(){
      this.$alert("更多内容请扫描下载APP体验", "", {
        confirmButtonText: "确定",
        showClose:false
      });
    },
    getOnlineCourseDetail: function() {
      var that = this;
      var id = this.$route.query.id;
      that.id = id;
      getData(config.apimethod.getOnlineCourseDetail + "?id=" + id, function(
        res
      ) {
        var data = res.data;
        data.has_teacher = 1;
        data.left_width = "";
        if (data.teacher == undefined || data.teacher.length <= 0) {
          data.has_teacher = 0;
          data.left_width = "100%";
        } else {
          that.teacher = data.teacher[0];
          that.teacher.teach_level_string = "";
          if(that.teacher.teach_level!=null){
            for (var i = 0; i < that.teacher.teach_level.length; i++) {
              if (i < that.teacher.teach_level.length - 1) {
                that.teacher.teach_level_string +=
                  that.teacher.teach_level[i] + " / ";
              } else {
                that.teacher.teach_level_string += that.teacher.teach_level[i];
              }
            }
          }
        }
        that.info = data;
      });
    }
  },
  mounted() {
	this.getOnlineCourseDetail();
	this.isIE();
  }
};
</script>

<style>
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}
.indexnews .ivu-card-body {
  padding: 0;
}
.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/online/detail.vue